import { h, Fragment } from "preact";

const wellKnownFields = [
    {
        id: "printer",
        description: "Nazwa drukarki",
        hidden: true
    }, {
        id: "tape-type",
        description: "Rodzaj taśmy",
        hidden: true
    }, {
        id: "tape-width",
        description: "Szerokość taśmy",
        hidden: true
    }, {
        id: "high-quality",
        description: "Wysoka jakość",
        hidden: true
    },  {
        id: "label-length",
        description: "Długość naklejki",
        hidden: true
    }, {
        id: "gs1-gtin13",
        description: "GTIN 13 dla GS1"
    }, {
        id: "gs1-gtin",
        description: "GTIN dla GS1"
    }, {
        id: "gs1-serial-number",
        description: "Numer seryjny dla GS1"
    }, {
        id: "gs1-production-date",
        description: "Data produkcji dla GS1"
    }
];

const staticValues = [
    {
        value: "{gs1}",
        name: "Wygenerowane GS1"
    },
    {
        value: "(01){field-gtin}",
        name: "HRI - GTIN"
    },
    {
        value: "(11){date:{field-date}:ymd}",
        name: "HRI - Production date"
    },
    {
        value: "(21){field-serial}",
        name: "HRI - Serial number"
    },
    {
        value: "(11){date:{field-date}:ymd}(21){field-serial}",
        name: "HRI - Production date + Serial number"
    },
]

export function LabelMetadataFieldEdit(props: { metadata: { [key: string]: string }, property: string, onChange: (newValue: string) => void}) {
    const v = props.property;

    return <>
        <select style="margin-left: 5px" type="text" value={
            staticValues.some(sv => sv.value === props.metadata[v]) ? (props.metadata[v] ?? "") : (
                props.metadata[v].startsWith("{") &&
                    props.metadata[v].endsWith("}") &&
                    Object.keys(props.metadata ?? {})
                        .filter(v => !v.startsWith("element-"))
                        .concat("gs1")
                        .map(v => `{${v}}`)
                        .indexOf(props.metadata[v]) >= 0
                    ? props.metadata[v] ?? ""
                    : "!!custom"
            )
        } onChange={(e) => props.onChange(e.currentTarget.value === "!!custom" ? "" : e.currentTarget.value)}>
            <option value="!!custom">Stała wartość</option>
            {staticValues.map(v => <option value={v.value}>{v.name}</option>)}
            {Object.keys(props.metadata ?? {})
                .filter(v => !v.startsWith("element-") && !v.startsWith("description-") && !wellKnownFields.find(f => f.id === v)?.hidden)
                .map(v => <option value={`{${v}}`}>
                    {wellKnownFields.find(f => f.id === v)?.description ?? (v.startsWith("field-")
                        ? (props.metadata["description-" + v] ? `${props.metadata["description-" + v]} (Pole '${v.substring(6)}')` : `Pole '${v.substring(6)}'`)
                        : `Wpis '${v}'`)}
                </option>)}
        </select>
        {staticValues.some(sv => sv.value === props.metadata[v]) || (
            props.metadata[v].startsWith("{") && props.metadata[v].endsWith("}") &&
                Object.keys(props.metadata ?? {})
                    .filter(v => !v.startsWith("element-"))
                    .concat("gs1")
                    .map(v => `{${v}}`)
                    .indexOf(props.metadata[v]) >= 0
        ) ? null : <input style="margin-left: 5px" type="text" value={props.metadata[v] ?? ""} onChange={(e) => props.onChange(e.currentTarget.value === "!!custom" ? "" : e.currentTarget.value)} />}
    </>;
}
